import type { Depot } from '@/data/schema/depot'
import { ApiService } from './api/api'

export default class DepotService {
	private apiService

	constructor() {
		this.apiService = new ApiService(true)
	}

	/**
	 * Get a single depot record
	 * @param id String
	 * @returns Promise
	 */
	get(id: string): Promise<any> {
		return this.apiService.get(`/depot/${id}`)
	}

	/**
	 * Get all depot records
	 * @param params Object
	 * @returns Promise
	 */
	getAll(params: Object, depots?: Array<string>): Promise<any> {
		let url = '/depot'

		if (depots) {
			url = url + '/' + depots.join('|')
		}

		return this.apiService.get(url, {
			params: params
		})
	}

	/**
	 * Update a depot
	 * @param data Object
	 * @param params Object
	 * @returns Promise
	 */
	update(id: string, depot: Depot, params?: Object): Promise<any> {
		return this.apiService.post(`/depot/${id}`, depot, {
			params: params
		})
	}

	/**
	 * Get all depots with distances
	 * @param destination String
	 * @returns Promise
	 */
	getWithDistances(destination: string): Promise<any> {
		return this.apiService.get(`/distance/${destination}`)
	}

	/**
	 * Get all the vehicles belonging to one or more depots
	 * @param depots string array
	 * @param delivery_type number
	 * @returns Promise
	 */
	getLoadVehicles(depots: string[], delivery_type: number): Promise<any> {
		return this.apiService.get(
			`/depot/${depots.join('|')}/vehicles?delivery_type=${delivery_type}`
		)
	}
}
